// extracted by mini-css-extract-plugin
export default {"boxcontainer":"SeriesBrowser_boxcontainer__2brIA","box":"SeriesBrowser_box__H-Izr","expanded":"SeriesBrowser_expanded__sw3p4"};